/**
 * @description 订单基础base
 * @author: 菩萨蛮
 * @date 2020/4/14 10:10 下午
 * @version V1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */

const OrderBase = {
  id: { title: '编号', visible: { new: false, modify: false } },
  status: { title: '状态', type: 'status', visible: { new: false, modify: false } },
  userId: { title: '单据负责人id', visible: false },
  userName: { title: '单据负责人', visible: false },
  operatorId: { title: '操作员id', visible: false },
  operatorName: { title: '操作员', visible: { check: true, table: false, new: false, modify: false } },
  remark: { title: '备注', sort: 9999, fieldIsShow: true, style: { overflow: true }  },
  gmtCreate: { type: 'time', title: '创建时间', visible: false },
  gmtModify: { type: 'time', title: '修改时间', visible: false }

};
export default OrderBase;
